import {Component, Input} from '@angular/core';
import {TeamServiceProvider} from "../../providers/team-service/team-service";
import {AppServiceProvider} from "../../providers/app-service/app-service";

@Component({
  selector: 'footer-app-download',
  templateUrl: 'footer-app-download.html'
})
export class FooterAppDownloadComponent {

  appData: any;
  isCustomApp: boolean = false;

  constructor(
    public teamService: TeamServiceProvider,
    public appService: AppServiceProvider
  ) {

  }

  setIsCustomApp(){
    this.isCustomApp = this.teamService.isCustomApp();
  }

  ngOnInit(){
      this.setIsCustomApp();
      this.appService.dataForAppByPackageName().then(appData => {
        this.appData = appData;
      });
  }

}



// WEBPACK FOOTER //
// ./src/components/footer-app-download/footer-app-download.ts